import React, { memo } from 'react';
import { pdfjs } from 'react-pdf';
import { AssetVersionItemDto } from '@api/Api';
import PlaybackPreparingLoader from '@pages/MediaViewer/AssetViewer/PlaybackPreparingLoader';
import type { MediaViewerMobileActionVisibility } from '@pages/MediaViewer/components/MediaViewerMobileAction/MediaViewerMobileAction';
import { useResponsive } from '@hooks/useResponsive';
import PdfCardDesktop from '@pages/MediaViewer/AssetViewer/PdfCard/PdfCardDesktop';
import PdfCardMobile from '@pages/MediaViewer/AssetViewer/PdfCard/PdfCardMobile';

import './PdfCard.less';

if (typeof (Promise as any).withResolvers === 'undefined') {
  (Promise as any).withResolvers = () => {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/legacy/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

export type PdfCardProps = {
  isExpand: boolean;
  setIsExpand(val: boolean): void;
  onReady: () => void;
  asset: AssetVersionItemDto;
  isPreparing: boolean;
  isAssetReady: boolean;
  mobileActionVisibility?: MediaViewerMobileActionVisibility | null;
};

export default memo(function PdfCard(props: PdfCardProps) {
  const { isMdWidth } = useResponsive();

  if (props.isPreparing) {
    return <PlaybackPreparingLoader />;
  }

  if (isMdWidth) {
    return <PdfCardMobile {...props} />;
  }

  return <PdfCardDesktop {...props} />;
});
